export const FAQS = [
  {
    q: "¿Qué es Aprea Gestora?",
    a: "Una empresa especializada en la gestión de incidencias físicas en pequeños comercios. Cuando algo falla en tu local, comunicas la incidencia y Aprea se encarga de gestionarla con el técnico especializado correspondiente.",
  },
  {
    q: "¿A quién está dirigido el servicio?",
    a: "A pequeños comercios y negocios con local físico: tiendas, restaurantes, peluquerías, centros de estética, oficinas pequeñas y comercios de proximidad.",
  },
  {
    q: "¿Qué tipo de incidencias gestiona Aprea?",
    a: "Incidencias físicas que afectan al funcionamiento normal del comercio: climatización y aire acondicionado, fontanería, averías eléctricas e incidencias relacionadas con las instalaciones.",
  },
  {
    q: "¿Cómo comunico una incidencia?",
    a: "Con una descripción del problema y un vídeo de la incidencia. Con esa información, Aprea inicia la gestión.",
  },
  {
    q: "¿Puedo enviar un vídeo?",
    a: "Sí. El vídeo forma parte de la notificación: ayuda a analizar la incidencia y a asignar al técnico adecuado desde el primer momento.",
  },
  {
    q: "¿Qué ocurre después de comunicar una incidencia?",
    a: "Aprea recibe y analiza la incidencia, te responde con la mayor brevedad posible y la comunica al técnico especializado correspondiente.",
  },
  {
    q: "¿Cómo funciona el plazo de 24 horas?",
    a: "Desde la gestión de la incidencia comienza la cuenta atrás: compromiso de disponer de un técnico especializado en tu comercio en un máximo de 24 horas hábiles.",
  },
  {
    q: "¿Qué se considera horario hábil?",
    a: "De 08:00 a 20:00. Solo las horas dentro de esa franja computan para el compromiso de 24 horas hábiles.",
  },
  {
    q: "¿Los domingos cuentan?",
    a: "No. Los domingos no computan como horas hábiles a efectos del servicio.",
  },
  {
    q: "¿Los festivos cuentan?",
    a: "No. Los días festivos no computan como horas hábiles a efectos del servicio.",
  },
  {
    q: "¿Tengo que buscar yo al técnico?",
    a: "No. Esa es exactamente la parte que desaparece: Aprea localiza y coordina al profesional especializado correspondiente.",
  },
  {
    q: "¿La cuota mensual incluye la gestión?",
    a: "Sí. El servicio funciona mediante una cuota mensual que cubre la gestión de tus incidencias. [CONDICIONES DEL SERVICIO]",
  },
  {
    q: "¿Cómo puedo darme de alta?",
    a: "Desde el botón DARME DE ALTA: completa el formulario con los datos de tu empresa y de la persona de contacto, acepta las Condiciones del Servicio y registraremos tu alta. En este paso no se realiza ningún pago.",
  },
];
